import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { FaRegCommentAlt } from "react-icons/fa";
import { ModalStatusErroDebito } from "../ModalStatusErroDebito";

interface IProps {
  motivoErro: string;
  dataErro?: string | null;
}

export function IconeErroDebito({ motivoErro, dataErro }: IProps) {
  const [show, setShow] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const iconRef = useRef<HTMLSpanElement>(null);

  const handleMouseEnter = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setCoords({ top: rect.top, left: rect.left + window.scrollX });
    }
    setShow(true);
  };

  return (
    <span
      ref={iconRef}
      style={{ display: "inline-flex" }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShow(false)}
    >
      <FaRegCommentAlt
        size={14}
        color="#6E6E6E"
        style={{ cursor: "pointer", flexShrink: 0 }}
      />
      {show &&
        createPortal(
          <ModalStatusErroDebito
            show={show}
            coords={coords}
            motivoErro={motivoErro}
            dataErro={dataErro}
          />,
          document.body,
        )}
    </span>
  );
}
